import { Component, input } from '@angular/core';

import { DocumentsListComponent } from '@camelot/files-basic';
import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';
import { BlockTextComponent } from '@camelot/wysiswyg';

import { TemplateVariant } from '../../../../services/dto/template';
import { CamTranslationCommunication } from '../../../../translation.service';

@Component({
  imports: [BlockTextComponent, DocumentsListComponent, TextComponent, TranslatePipe],
  selector: 'cam-choice-detail',
  styleUrls: ['./detail.component.scss'],
  templateUrl: './detail.component.html',
})
export class ChoiceDetailComponent {
  public variant = input.required<TemplateVariant>();

  constructor() {
    CamTranslationCommunication.getInstance();
  }
}
